import React, { useEffect, useRef } from 'react'

import { useApiAction } from '../../api/useApiAction'
import Loader from '../loadingScreen/loader'

export default function RedirectUrl() {
  const formRef = useRef<HTMLFormElement>(null)
  const { data } = useApiAction()
  if (data?.metadata?.redirect_url) {
    let redirect_url = data?.metadata?.redirect_url
    let apiCallJSON = JSON.parse(redirect_url)
    if (apiCallJSON) {
      var { url, encSessionKey, encRequestData } = apiCallJSON
    }
  }

  const onFormLoad = () => {
    formRef.current?.submit()
  }

  useEffect(() => {
    onFormLoad()
  }, [])

  return (
    <>
      <form ref={formRef} action={url} method="post">
        <input type="hidden" name="encSessionKey" value={encSessionKey} />
        <input type="hidden" name="encRequestData" value={encRequestData} />
        <button type="submit" />
      </form>
      <Loader />
    </>
  )
}
